namespace RioERP.Orders {
    export namespace PermissionKeys {
        export const General = "Orders:General";

        namespace OrdersManagement {
            export const Delete = "Orders:OrdersManagement:Delete";
            export const Modify = "Orders:OrdersManagement:Modify";
            export const View = "Orders:OrdersManagement:View";
        }

        namespace FranchiseeOrdersManagement {
            export const Delete = "Orders:FranchiseeOrdersManagement:Delete";
            export const Modify = "Orders:FranchiseeOrdersManagement:Modify";
            export const View = "Orders:FranchiseeOrdersManagement:View";
        }

        namespace TeachersOrdersManagement {
            export const Delete = "Orders:TeachersOrdersManagement:Delete";
            export const Modify = "Orders:TeachersOrdersManagement:Modify";
            export const View = "Orders:TeachersOrdersManagement:View";
        }
    }
}
